import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';
import { INIT, LOADING, SUCCESS, ERROR } from '../../utils/constants';
import { fetchAlertSuccess, fetchAlertError } from '../alert-ui/duck';
import {
  updateProfileAPI,
  getProfileAPI,
  getProfileStatusAPI,
  changePasswordAPI,
  getAllUsersAPI,
  getUserLogsAPI,
  getClientProfileAPI,
  deleteUserAPI,
  patchAdminPrivilegesAPI,
  demoteAdminPrivilegesAPI,
  getAdminProfileAPI,
  getAllAdminsAPI,
} from './api';

export const UPDATE_PROFILE = 'advaice/user/UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'advaice/user/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'advaice/user/UPDATE_PROFILE_ERROR';

export const GET_PROFILE = 'advaice/user/GET_PROFILE';
export const GET_PROFILE_SUCCESS = 'advaice/user/GET_PROFILE_SUCCESS';
export const GET_PROFILE_ERROR = 'advaice/user/GET_PROFILE_ERROR';

export const GET_CLIENT_PROFILE = 'advaice/user/GET_CLIENT_PROFILE';
export const GET_CLIENT_PROFILE_SUCCESS = 'advaice/user/GET_CLIENT_PROFILE_SUCCESS';
export const GET_CLIENT_PROFILE_ERROR = 'advaice/user/GET_CLIENT_PROFILE_ERROR';

export const GET_ADMIN_PROFILE = 'advaice/user/GET_ADMIN_PROFILE';
export const GET_ADMIN_PROFILE_SUCCESS = 'advaice/user/GET_ADMIN_PROFILE_SUCCESS';
export const GET_ADMIN_PROFILE_ERROR = 'advaice/user/GET_ADMIN_PROFILE_ERROR';

export const DEMOTE_USER_ADMIN_PRIVILEGE = 'advaice/user/DEMOTE_USER_ADMIN_PRIVILEGE';
export const PATCH_USER_ADMIN_PRIVILEGE = 'advaice/user/PATCH_USER_ADMIN_PRIVILEGE';
export const PATCH_USER_ADMIN_PRIVILEGE_ERROR = 'advaice/user/PATCH_USER_ADMIN_PRIVILEGE_ERROR';
export const PATCH_USER_ADMIN_PRIVILEGE_SUCCESS = 'advaice/user/PATCH_USER_ADMIN_PRIVILEGE_SUCCESS';

export const GET_PROFILE_STATUS = 'advaice/user/GET_PROFILE_STATUS';
export const GET_PROFILE_STATUS_SUCCESS =
  'advaice/user/GET_PROFILE_STATUS_SUCCESS';
export const GET_PROFILE_STATUS_ERROR = 'advaice/user/GET_PROFILE_STATUS_ERROR';

export const CHANGE_PASSWORD = 'advaice/user/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'advaice/user/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'advaice/user/CHANGE_PASSWORD_ERROR';

export const GET_USERS_WITH_APPS = 'advaice/user/GET_USERS_WITH_APPS';
export const GET_USERS_WITH_APPS_SUCCESS = 'advaice/user/GET_USERS_WITH_APPS_SUCCESS';
export const GET_USERS_WITH_APPS_ERROR = 'advaice/user/GET_USERS_WITH_APPS_ERROR';

export const GET_ALL_USERS_SHORT = 'advaice/user/GET_ALL_USERS_SHORT';
export const GET_ALL_USERS_SHORT_SUCCESS = 'advaice/user/GET_ALL_USERS_SHORT_SUCCESS';
export const GET_ALL_USERS_SHORT_ERROR = 'advaice/user/GET_ALL_USERS_SHORT_ERROR';

export const GET_ALL_USERS_FULL = 'advaice/user/GET_ALL_USERS_FULL';
export const GET_ALL_USERS_FULL_SUCCESS = 'advaice/user/GET_ALL_USERS_FULL_SUCCESS';
export const GET_ALL_USERS_FULL_ERROR = 'advaice/user/GET_ALL_USERS_FULL_ERROR';

export const GET_ALL_ADMINS_FULL = 'advaice/user/GET_ALL_ADMINS_FULL';
export const GET_ALL_ADMINS_FULL_SUCCESS = 'advaice/user/GET_ALL_ADMINS_FULL_SUCCESS';
export const GET_ALL_ADMINS_FULL_ERROR = 'advaice/user/GET_ALL_ADMINS_FULL_ERROR';

export const GET_USER_LOGS = 'advaice/user/GET_USER_LOGS';
export const GET_USER_LOGS_SUCCESS = 'advaice/user/GET_USER_LOGS_SUCCESS';
export const GET_USER_LOGS_ERROR = 'advaice/user/GET_USER_LOGS_ERROR';

export const UPDATE_PROFILE_STATUS = 'advaice/user/UPDATE_PROFILE_STATUS';

export const DELETE_SELECTED_USER = 'advaice/user/DELETE_SELECTED_USER';
export const DELETE_SELECTED_USER_ERROR = 'advaice/user/DELETE_SELECTED_ERROR';

export const DELETE_SELECTED_ADMIN = 'advaice/user/DELETE_SELECTED_ADMIN';
export const DELETE_SELECTED_ADMIN_ERROR = 'advaice/user/DELETE_SELECTED_ADMIN_ERROR';

export const ANNUL_ERROR = 'advaice/user/ANNUL_ERROR';

export const SET_USER = 'advaice/user/SET_USER';

export const SET_ALERT_STATUS = 'advaice/user/SET_ALERT_STATUS';

export const RESET_CHANGE_PASSWORD_STATUS = 'advaice/user/RESET_CHANGE_PASSWORD_STATUS';

export const RESET_USER_LOGS = 'advaice/user/RESET_USER_LOGS';

export const RESET_STORE = 'advaice/user/RESET_STORE';

export const RESET_USERS_WITH_APPS = 'advaice/user/RESET_USERS_WITH_APPS';
export const RESET_USER_WITH_APPS_ARRAY = 'advaice/user/RESET_USER_WITH_APPS_ARRAY';

export const SIDE_BAR_STATUS = 'advaice/user/SIDE_BAR_STATUS';

const initialState = {
  status: INIT,
  id: -1,
  havePassword: false,
  email: '',
  error: '',
  profile: {
    fullName: '',
    company: '',
    website: '',
    position: '',
    timezone: '',
    role: '',
  },
  cardMethod: {
    lastFour: '',
    brand: '',
    active: false,
  },
  invoiceMethod: {
    bankName: '',
    country: '',
    active: false,
  },
  clientProfile: {
    profile: {},
  },
  adminProfile: {
    profile: {},
  },
  clientProfileStatus: INIT,
  clientProfileError: '',
  adminProfileStatus: INIT,
  adminProfileError: '',
  emailSubscriptions: {},
  updateProfileStatus: INIT,
  changePasswordStatus: INIT,
  changePasswordError: '',
  profileStepStatus: INIT,
  onlyUsersWithApps: [],
  usersWithApps: [],
  pageUsersWithApps: -1,
  hasMoreUsersWithApps: true,
  usersWithAppsStatus: INIT,
  usersShort: [],
  pageUsersShort: 0,
  hasMoreUsersShort: true,
  usersShortStatus: INIT,
  userLogs: [],
  userLogsStatus: INIT,
  hasMoreUserLogs: true,
  pageUserLogs: -1,
  usersFull: [],
  pageUsersFull: 0,
  hasMoreUsersFull: true,
  usersFullStatus: INIT,
  adminsFull: [],
  pageAdminsFull: 0,
  hasMoreAdminsFull: true,
  adminsFullStatus: INIT,
  balance: {
    amount: 0,
    lastUpdate: 0,
  },
  alertPopup: {
    messageAlert: '',
    typeAlert: 0,
    statusAlert: false,
  },
  sidebarStatus: true,
};

export const userStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_PROFILE: {
      return {
        ...state,
        updateProfileStatus: LOADING,
      };
    }
    case UPDATE_PROFILE_SUCCESS: {
      const {
        profile: {
          fullName, company, website, position, timezone, role,
        },
        balance: {
          amount,
          lastUpdate,
        },
        cardMethod,
        invoiceMethod,
      } = action.payload;
      const newCardMethod = {
        lastFour: '',
        brand: '',
      };
      if (cardMethod) {
        newCardMethod.lastFour = cardMethod.lastFour;
        newCardMethod.brand = cardMethod.brand;
        newCardMethod.active = true;
      }
      const newInvoiceMethod = {
        bankName: '',
        country: '',
      };
      if (invoiceMethod) {
        newInvoiceMethod.bankName = invoiceMethod.bankName;
        newInvoiceMethod.country = invoiceMethod.country;
        newInvoiceMethod.active = true;
      }
      return {
        ...state,
        updateProfileStatus: SUCCESS,
        id: action.payload.id,
        havePassword: action.payload.havePassword,
        email: action.payload.email,
        profile: {
          ...state.profile,
          fullName,
          company,
          website,
          position,
          timezone,
          role,
        },
        balance: {
          ...state.balance,
          amount,
          lastUpdate,
        },
        cardMethod: newCardMethod,
        invoiceMethod: newInvoiceMethod,
        emailSubscriptions: action.payload.emailSubscriptions,
      };
    }
    case GET_PROFILE_SUCCESS: {
      const {
        profile: {
          fullName, company, website, position, timezone, role,
        },
        balance: {
          amount,
          lastUpdate,
        },
        cardMethod,
        invoiceMethod,
      } = action.payload;
      const newCardMethod = {
        lastFour: '',
        brand: '',
      };
      if (cardMethod) {
        newCardMethod.lastFour = cardMethod.lastFour;
        newCardMethod.brand = cardMethod.brand;
        newCardMethod.active = true;
      }
      const newInvoiceMethod = {
        bankName: '',
        country: '',
      };
      if (invoiceMethod) {
        newInvoiceMethod.bankName = invoiceMethod.bankName;
        newInvoiceMethod.country = invoiceMethod.country;
        newInvoiceMethod.active = true;
      }
      return {
        ...state,
        status: SUCCESS,
        id: action.payload.id,
        havePassword: action.payload.havePassword,
        email: action.payload.email,
        profile: {
          ...state.profile,
          fullName,
          company,
          website,
          position,
          timezone,
          role,
        },
        balance: {
          ...state.balance,
          amount,
          lastUpdate,
        },
        cardMethod: newCardMethod,
        invoiceMethod: newInvoiceMethod,
        emailSubscriptions: action.payload.emailSubscriptions,
      };
    }
    case UPDATE_PROFILE_ERROR: {
      return {
        ...state,
        updateProfileStatus: ERROR,
        error: action.payload,
      };
    }
    case PATCH_USER_ADMIN_PRIVILEGE_ERROR: {
      return {
        ...state,
        alertPopup: {
          messageAlert: 'Upgrade encountered an error',
          typeAlert: 3,
          statusAlert: true,
        },
      };
    }
    case PATCH_USER_ADMIN_PRIVILEGE_SUCCESS: {
      return {
        ...state,
        alertPopup: {
          messageAlert: 'Successful promotion to administrator',
          typeAlert: 1,
          statusAlert: true,
        },
      };
    }
    case GET_PROFILE_ERROR: {
      return {
        ...state,
        status: ERROR,
        error: action.payload,
      };
    }
    case GET_PROFILE: {
      return {
        ...state,
        status: LOADING,
      };
    }
    case GET_PROFILE_STATUS: {
      return {
        ...state,
        status: LOADING,
      };
    }
    case GET_PROFILE_STATUS_SUCCESS: {
      return {
        ...state,
        status: GET_PROFILE_STATUS_SUCCESS,
        profileStepStatus: action.payload,
      };
    }
    case DELETE_SELECTED_USER: {
      return {
        ...state,
      };
    }
    case DELETE_SELECTED_ADMIN: {
      return {
        ...state,
      };
    }
    case UPDATE_PROFILE_STATUS: {
      return {
        ...state,
        profileStepStatus: action.payload,
      };
    }
    case CHANGE_PASSWORD: {
      return {
        ...state,
        changePasswordStatus: LOADING,
      };
    }
    case CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        changePasswordStatus: SUCCESS,

      };
    }

    case CHANGE_PASSWORD_ERROR: {
      return {
        ...state,
        changePasswordStatus: ERROR,
        changePasswordError: action.payload,
      };
    }
    case GET_CLIENT_PROFILE: {
      return {
        ...state,
        clientProfileStatus: LOADING,
      };
    }
    case GET_CLIENT_PROFILE_SUCCESS: {
      return {
        ...state,
        clientProfileStatus: SUCCESS,
        clientProfile: action.payload,
      };
    }
    case GET_CLIENT_PROFILE_ERROR: {
      return {
        ...state,
        clientProfileError: action.payload,
      };
    }
    case GET_ADMIN_PROFILE: {
      return {
        ...state,
        adminProfileStatus: LOADING,
      };
    }
    case GET_ADMIN_PROFILE_SUCCESS: {
      return {
        ...state,
        adminProfileStatus: SUCCESS,
        adminProfile: action.payload,
      };
    }
    case GET_ADMIN_PROFILE_ERROR: {
      return {
        ...state,
        adminProfileError: action.payload,
      };
    }
    case GET_USERS_WITH_APPS: {
      return {
        ...state,
        usersWithAppsStatus: LOADING,
      };
    }
    case GET_USERS_WITH_APPS_SUCCESS: {
      const prevState = action.payload.first ? [] : state.usersWithApps;
      return {
        ...state,
        usersWithAppsStatus: SUCCESS,
        usersWithApps: [...prevState, ...action.payload.content],
        hasMoreUsersWithApps: !action.payload.last,
        pageUsersWithApps: action.payload.number,
      };
    }
    case RESET_USER_WITH_APPS_ARRAY: {
      return {
        ...state,
        usersWithAppsStatus: INIT,
        usersWithApps: [],
        // hasMoreUsersWithApps: true,
        pageUsersWithApps: -1,
      };
    }
    case RESET_USERS_WITH_APPS: {
      return {
        ...state,
        usersWithAppsStatus: INIT,
        usersWithApps: [],
        hasMoreUsersWithApps: true,
        pageUsersWithApps: -1,
      };
    }

    case GET_ALL_USERS_SHORT: {
      return {
        ...state,
        usersShortStatus: LOADING,
      };
    }
    case GET_ALL_USERS_SHORT_SUCCESS: {
      const prevUsers = action.payload.first ? [] : state.usersShort;
      return {
        ...state,
        usersShortStatus: SUCCESS,
        usersShort: [...prevUsers, ...action.payload.content],
        hasMoreUsersShort: !action.payload.last,
        pageUsersShort: action.payload.number,
      };
    }
    case GET_ALL_USERS_FULL: {
      return {
        ...state,
        usersFullStatus: LOADING,
      };
    }
    case GET_ALL_USERS_FULL_SUCCESS: {
      const currentUsers = action.payload.first ? [] : state.usersFull;
      return {
        ...state,
        usersFullStatus: SUCCESS,
        usersFull: [...currentUsers, ...action.payload.content],
        hasMoreUsersFull: !action.payload.last,
        pageUsersFull: action.payload.number,
      };
    }
    case GET_ALL_ADMINS_FULL: {
      return {
        ...state,
        adminsFullStatus: LOADING,
      };
    }
    case GET_ALL_ADMINS_FULL_SUCCESS: {
      const currentAdmins = action.payload.first ? [] : state.usersFull;
      return {
        ...state,
        adminsFullStatus: SUCCESS,
        adminsFull: [...currentAdmins, ...action.payload.content],
        hasMoreAdminsFull: !action.payload.last,
        pageAdminsFull: action.payload.number,
      };
    }

    case GET_USER_LOGS: {
      return {
        ...state,
        userLogsStatus: LOADING,
      };
    }
    case GET_USER_LOGS_SUCCESS: {
      const currentLogs = action.payload.first ? [] : state.userLogs;
      return {
        ...state,
        userLogsStatus: SUCCESS,
        userLogs: [...currentLogs, ...action.payload.content],
        hasMoreUserLogs: !action.payload.last,
        pageUserLogs: action.payload.number,
      };
    }

    case ANNUL_ERROR: {
      return {
        ...state,
        status: INIT,
        error: '',
      };
    }
    case RESET_CHANGE_PASSWORD_STATUS: {
      return {
        ...state,
        changePasswordStatus: INIT,
        changePasswordError: '',
      };
    }
    case SET_ALERT_STATUS: {
      return {
        ...state,
        alertPopup: {
          statusAlert: action.payload,
          typeAlert: 0,
          messageAlert: '',
        },
      };
    }
    case SET_USER: {
      const {
        profile: {
          fullName, company, website, position, timezone, role,
        },
        id,
        havePassword,
        email,
      } = action.payload;
      return {
        ...state,
        id,
        havePassword,
        email,
        profile: {
          ...state.profile,
          fullName,
          company,
          website,
          position,
          role,
          timezone,
        },
        emailSubscriptions: action.payload.emailSubscriptions,
      };
    }
    case RESET_USER_LOGS: {
      return {
        ...state,
        userLogs: [],
        userLogsStatus: INIT,
        hasMoreUserLogs: true,
        pageUserLogs: -1,
      };
    }
    case RESET_STORE: {
      return {
        status: INIT,
        id: -1,
        havePassword: false,
        email: '',
        error: '',
        profile: {
          fullName: '',
          company: '',
          website: '',
          position: '',
          timezone: '',
          role: '',
        },
        cardMethod: {
          lastFour: '',
          brand: '',
          active: false,
        },
        invoiceMethod: {
          bankName: '',
          country: '',
          active: false,
        },
        clientProfile: {
          profile: {},
        },
        clientProfileStatus: INIT,
        clientProfileError: '',
        emailSubscriptions: {},
        updateProfileStatus: INIT,
        changePasswordStatus: INIT,
        changePasswordError: '',
        profileStepStatus: INIT,
        usersWithApps: [],
        pageUsersWithApps: -1,
        hasMoreUsersWithApps: true,
        usersWithAppsStatus: INIT,
        usersShort: [],
        pageUsersShort: 0,
        hasMoreUsersShort: true,
        usersShortStatus: INIT,
        userLogs: [],
        userLogsStatus: INIT,
        hasMoreUserLogs: true,
        pageUserLogs: -1,
        usersFull: [],
        pageUsersFull: 0,
        hasMoreUsersFull: true,
        usersFullStatus: INIT,
        balance: {
          amount: 0,
          lastUpdate: 0,
        },
      };
    }
    case SIDE_BAR_STATUS: {
      return {
        ...state,
        sidebarStatus: !state.sidebarStatus,
      };
    }
    default: {
      return state;
    }
  }
};
export const sideBarChangeStatus = () => ({ type: SIDE_BAR_STATUS });

export const resetUserLogs = () => ({ type: RESET_USER_LOGS });

export const resetChangePasswordStatus = () => ({ type: RESET_CHANGE_PASSWORD_STATUS });

export const annulUserError = () => ({ type: ANNUL_ERROR });

export const setUser = data => ({ type: SET_USER, payload: data });

export const setAlertStatus = data => ({ type: SET_ALERT_STATUS, payload: data });

export const resetUserStore = () => ({ type: RESET_STORE });

export const resetUsersWithApps = () => ({ type: RESET_USERS_WITH_APPS });

export const resetUsersWithAppsArray = () => ({ type: RESET_USER_WITH_APPS_ARRAY });

export const getClientProfile = (data) => {
  const newData = { ...data };
  newData.role = 'USER';
  return {
    type: GET_CLIENT_PROFILE,
    payload: data,
  };
};

export const getAdminProfile = (data) => {
  const newData = { ...data };
  newData.role = 'ADMIN';
  return {
    type: GET_ADMIN_PROFILE,
    payload: newData,
  };
};

export const updateProfile = data => ({
  type: UPDATE_PROFILE,
  payload: data,
});

export const getUsersWithApps = (data) => {
  const newData = { ...data };
  newData.projection = 'WITH_APPS';
  newData.role = 'USER';
  return {
    type: GET_USERS_WITH_APPS,
    payload: newData,
  };
};

export const getAllUsersShort = (data) => {
  const newData = { ...data };
  newData.projection = 'SHORT';
  newData.role = 'USER';
  return {
    type: GET_ALL_USERS_SHORT,
    payload: newData,
  };
};

export const getAllUsersFull = (data) => {
  const newData = { ...data };
  newData.projection = 'FULL';
  newData.role = 'USER';
  return {
    type: GET_ALL_USERS_FULL,
    payload: newData,
  };
};

export const getAllAdminsFull = (data) => {
  const newData = { ...data };
  newData.projection = 'FULL';
  newData.role = 'ADMIN';
  return {
    type: GET_ALL_ADMINS_FULL,
    payload: newData,
  };
};

export const getProfile = () => ({ type: GET_PROFILE });

export const getUserLogs = data => ({
  type: GET_USER_LOGS,
  payload: data,
});

export const getProfileStatus = () => ({ type: GET_PROFILE_STATUS });

export const changePassword = data => ({
  type: CHANGE_PASSWORD,
  payload: data,
});

export const updateProfileStatus = data => ({
  type: UPDATE_PROFILE_STATUS,
  payload: data,
});

export const deleteUser = data => ({
  type: DELETE_SELECTED_USER,
  payload: data,
});

export const deleteAdmin = data => ({
  type: DELETE_SELECTED_ADMIN,
  payload: data,
});

export const patchUserPrivilege = data => ({
  type: PATCH_USER_ADMIN_PRIVILEGE,
  payload: data,
});

export const patchUserDemotePrivilege = data => ({
  type: DEMOTE_USER_ADMIN_PRIVILEGE,
  payload: data,
});

export const updateProfileObservable = (store, requestData) =>
  Observable.fromPromise(updateProfileAPI(requestData))
    .map(({ data }) => ({ type: UPDATE_PROFILE_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: UPDATE_PROFILE_ERROR, payload: err }));

export const getUserAdminPrivilegeObservable = (store, requestData) =>
  Observable.fromPromise(patchAdminPrivilegesAPI(requestData))
    .map(() => fetchAlertSuccess('The user is promoted to administrator'))
    .catch(err => Observable.of(() => fetchAlertError(err)));

export const demoteUserAdminPrivilegeObservable = (store, requestData) =>
  Observable.fromPromise(demoteAdminPrivilegesAPI(requestData))
    .map(() => fetchAlertSuccess('The admin is promoted to user'))
    .catch(err => Observable.of(() => fetchAlertError(err)));

export const getAdminProfileObservable = (store, requestData) =>
  Observable.fromPromise(getAdminProfileAPI(requestData))
    .map(({ data }) => ({ type: GET_ADMIN_PROFILE_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: GET_ADMIN_PROFILE_ERROR, payload: err }));

export const getClientProfileObservable = (store, requestData) =>
  Observable.fromPromise(getClientProfileAPI(requestData))
    .map(({ data }) => ({ type: GET_CLIENT_PROFILE_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: GET_CLIENT_PROFILE_ERROR, payload: err }));

export const getProfileStatusObservable = (store, requestData) =>
  Observable.fromPromise(getProfileStatusAPI(requestData))
    .map(({ data }) => ({ type: GET_PROFILE_STATUS_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: GET_PROFILE_STATUS_ERROR, payload: err }));

export const getUsersWithAppsObservable = (store, requestData) =>
  Observable.fromPromise(getAllUsersAPI(requestData))
    .map(({ data }) => ({ type: GET_USERS_WITH_APPS_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: GET_USERS_WITH_APPS_ERROR, payload: err }));

export const getUserLogsObservable = (store, requestData) =>
  Observable.fromPromise(getUserLogsAPI(requestData))
    .map(({ data }) => ({ type: GET_USER_LOGS_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: GET_USER_LOGS_ERROR, payload: err }));

export const getAllUsersShortObservable = (store, requestData) =>
  Observable.fromPromise(getAllUsersAPI(requestData))
    .map(({ data }) => ({ type: GET_ALL_USERS_SHORT_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: GET_ALL_USERS_SHORT_ERROR, payload: err }));

export const getAllUsersFullObservable = (store, requestData) =>
  Observable.fromPromise(getAllUsersAPI(requestData))
    .map(({ data }) => ({ type: GET_ALL_USERS_FULL_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: GET_ALL_USERS_FULL_ERROR, payload: err }));

export const getAllAdminsFullObservable = (store, requestData) =>
  Observable.fromPromise(getAllAdminsAPI(requestData))
    .map(({ data }) => ({ type: GET_ALL_ADMINS_FULL_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: GET_ALL_ADMINS_FULL_ERROR, payload: err }));

export const getProfileObservable = () =>
  Observable.fromPromise(getProfileAPI())
    .map(({ data }) => ({ type: GET_PROFILE_SUCCESS, payload: data }))
    .catch(err => Observable.of({ type: GET_PROFILE_ERROR, payload: err }));

export const changePasswordObservable = (store, requestData) =>
  Observable.fromPromise(changePasswordAPI(requestData))
    .map(({ data }) => ({ type: CHANGE_PASSWORD_SUCCESS, payload: data }))
    .catch(err =>
      Observable.of({ type: CHANGE_PASSWORD_ERROR, payload: err }));

export const deleteUserObservable = (store, requestData) =>
  Observable.fromPromise(deleteUserAPI(requestData))
    .map(() => getAllUsersFull())
    .catch(err => Observable.of(fetchAlertError(err)));

export const deleteAdminObservable = (store, requestData) =>
  Observable.fromPromise(deleteUserAPI(requestData))
    .map(() => getAllAdminsFull())
    .catch(err => Observable.of(fetchAlertError(err)));

export const deleteUserEpic = (action$, store) =>
  action$
    .ofType(DELETE_SELECTED_USER)
    .flatMap(action => deleteUserObservable(store, action.payload));

export const deleteAdminEpic = (action$, store) =>
  action$
    .ofType(DELETE_SELECTED_ADMIN)
    .flatMap(action => deleteAdminObservable(store, action.payload));

export const updateProfileEpic = (action$, store) =>
  action$
    .ofType(UPDATE_PROFILE)
    .flatMap(action => updateProfileObservable(store, action.payload));

export const getProfileEpic = (action$, store) =>
  action$
    .ofType(GET_PROFILE)
    .flatMap(action => getProfileObservable(store, action.payload));

export const getUserLogsEpic = (action$, store) =>
  action$
    .ofType(GET_USER_LOGS)
    .flatMap(action => getUserLogsObservable(store, action.payload));

export const getProfileStatusEpic = (action$, store) =>
  action$
    .ofType(GET_PROFILE_STATUS)
    .flatMap(action => getProfileStatusObservable(store, action.payload));

export const changePasswordEpic = (action$, store) =>
  action$
    .ofType(CHANGE_PASSWORD)
    .flatMap(action => changePasswordObservable(store, action.payload));

export const getUsersWithAppsEpic = (action$, store) =>
  action$
    .ofType(GET_USERS_WITH_APPS)
    .flatMap(action => getUsersWithAppsObservable(store, action.payload));

export const getAllUsersFullEpic = (action$, store) =>
  action$
    .ofType(GET_ALL_USERS_FULL)
    .flatMap(action => getAllUsersFullObservable(store, action.payload));

export const getAllAdminsFullEpic = (action$, store) =>
  action$
    .ofType(GET_ALL_ADMINS_FULL)
    .flatMap(action => getAllAdminsFullObservable(store, action.payload));

export const getAllUsersShortEpic = (action$, store) =>
  action$
    .ofType(GET_ALL_USERS_SHORT)
    .flatMap(action => getAllUsersShortObservable(store, action.payload));
export const getClientProfileEpic = (action$, store) =>
  action$
    .ofType(GET_CLIENT_PROFILE)
    .flatMap(action => getClientProfileObservable(store, action.payload));
export const getAdminProfileEpic = (action$, store) =>
  action$
    .ofType(GET_ADMIN_PROFILE)
    .flatMap(action => getAdminProfileObservable(store, action.payload));

export const getUserAdminPrivilegeEpic = (action$, store) =>
  action$
    .ofType(PATCH_USER_ADMIN_PRIVILEGE)
    .flatMap(action => getUserAdminPrivilegeObservable(store, action.payload));

export const demoteUserAdminPrivilegeEpic = (action$, store) =>
  action$
    .ofType(DEMOTE_USER_ADMIN_PRIVILEGE)
    .flatMap(action => demoteUserAdminPrivilegeObservable(store, action.payload));

export const userEpic = combineEpics(
  updateProfileEpic,
  getProfileEpic,
  getProfileStatusEpic,
  changePasswordEpic,
  getUsersWithAppsEpic,
  getAllUsersShortEpic,
  getAllUsersFullEpic,
  getUserLogsEpic,
  getClientProfileEpic,
  getAdminProfileEpic,
  deleteUserEpic,
  deleteAdminEpic,
  getUserAdminPrivilegeEpic,
  demoteUserAdminPrivilegeEpic,
  getAllAdminsFullEpic,
);




// WEBPACK FOOTER //
// ./src/reducers/user/duck.js